module.exports = __webpack_public_path__ + "static/media/19.08.a015370b.webp";